import React, {useRef} from 'react';

import CSSModules from 'react-css-modules';

import Button from '../../../Button';
import {useDirection} from '../../../hooks/useDirection';
import {ArrowIcon} from '../../../icons';
import ShrinkText from '../../../ShrinkText';
import PreviewProgressButton from './PreviewProgressButton';

import styles from './styles.module.scss';

type PreviewNavButtonProps = {
  background: string;
  button: {
    text: string;
  };
  isLightTheme?: boolean;
  showStickyBottomBackground?: boolean;
};

const PreviewNavButton = ({
  button,
  background,
  isLightTheme = false,
  showStickyBottomBackground = true,
}: PreviewNavButtonProps): JSX.Element => {
  const containerRef = useRef<HTMLDivElement>(null);
  const direction = useDirection(containerRef);

  const stickyBottomBackgroundColor = showStickyBottomBackground
    ? {
        backgroundImage: `linear-gradient(
      180deg,
      ${background}B3 0%,
      ${background} 24.48%,
      ${background} 100%)`,
      }
    : {};

  return (
    <div
      ref={containerRef}
      style={{...stickyBottomBackgroundColor, direction}}
      styleName='button-sticky-bottom'
    >
      <div>
        <Button
          onClick={() => null}
          noMarginTop
          noMarginLeft
          icon={<ArrowIcon orientation='left' />}
          disabled={false}
          isLightTheme={isLightTheme}
          type='progress'
        />
      </div>
      {button.text ? (
        <ShrinkText maxPxWidth={200} startingFontSize='m' minimumFontSize='s'>
          <PreviewProgressButton
            icon={<ArrowIcon orientation='right' />}
            isLightTheme={isLightTheme}
            text={button.text}
          />
        </ShrinkText>
      ) : (
        <Button
          onClick={() => null}
          noMarginTop
          noMarginLeft
          icon={<ArrowIcon orientation='right' />}
          disabled={false}
          isLightTheme={isLightTheme}
          type='progress'
          dataAutomation='preview-nav-button'
        />
      )}
    </div>
  );
};

export default CSSModules(PreviewNavButton, styles);
